var m = require('mithril');

var NAME_COLUMN_WIDTH = '24%';
var SELECT_COLUMN_WIDTH = '2.5rem';

function normalizeColumn(column) {
  if (typeof column === 'string') {
    return { key: column };
  }
  return column || {};
}

function isNameColumn(column) {
  var key = column.key || column.name || column.label;
  return String(key || '').toLowerCase() === 'name';
}

function attrsForColumn(column) {
  var width = column.width || (isNameColumn(column) ? NAME_COLUMN_WIDTH : null);
  if (!width) return {};
  if (String(width).indexOf('%') >= 0) return { width: width };
  return { style: { width: width } };
}

function colgroup(columns) {
  return m('colgroup', (columns || []).map(function (column) {
    return m('col', attrsForColumn(normalizeColumn(column)));
  }));
}

function withSelection(columns) {
  return [{ key: 'select', width: SELECT_COLUMN_WIDTH }].concat(columns || []);
}

module.exports = {
  NAME_COLUMN_WIDTH: NAME_COLUMN_WIDTH,
  SELECT_COLUMN_WIDTH: SELECT_COLUMN_WIDTH,
  colgroup: colgroup,
  withSelection: withSelection
};
